module.exports = "<app-alert></app-alert>\n<div toastContainer></div>\n<app-spinner name=\"omsSpinner\"></app-spinner>\n<app-spinner name=\"offerSpinner\"></app-spinner>\n<app-spinner name=\"uploadSpinner\"></app-spinner>\n<app-spinner name=\"meterSpinner\"></app-spinner>\n<div class=\"app\">\n    <router-outlet></router-outlet>\n</div>\n<!--<app-footer></app-footer>-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main